import React, { useContext } from 'react';
import cls from 'classnames';
import { CreditCheckForm } from './credit_check_form';
import { SalesContext } from '../../SalesContext';
import styles from './credit_check.module.scss';
import { CredibilityIndicator } from './credibility_indicator';
import Bundle from '../../models/Bundle';
import CreditCheckResult from '../../models/CreditCheckResult';
import { AppConfig } from '../../config';
import Product from '../../models/Product';

/**
 * View for performing a credit check for a provided personal number.
 */
export const CreditCheckView: React.FC = () => {
  const { creditCheckResult, setCreditCheckResult, config, setBundles, products, isDemo } = useContext(SalesContext);

  return (
    <div id="creditcheck" className="view">
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <CreditCheckForm
          onEnergyAgreementSubmit={result => {
            setCreditCheckResult(result);

            document.getElementById('order').scrollIntoView({
              behavior: 'smooth'
            });
          }}
          onResult={result => {
            setCreditCheckResult(result);
          }}
          isDemo={isDemo}
        />
        {
          creditCheckResult?.credibility ? (
            <div className={cls([styles.credibility, typeof creditCheckResult.credibility ? styles.visible : null])}>
              <CredibilityIndicator credibility={creditCheckResult.credibility} credibilityDescription={creditCheckResult.status} />
            </div>
          ) : null
        }
      </div>
    </div >
  );
}

export default CreditCheckView;